import React, { createContext, useReducer } from 'react';
import passwordValidator from 'password-validator';

export const passwordSchema = new passwordValidator();

//prettier-ignore
passwordSchema
    .is().min(12)
    .has().uppercase()
    .has().lowercase()
    .has().digits();

const PERSIST_LOGIN_START = 'PERSIST_LOGIN_START';
const PERSIST_LOGIN_SUCCESS = 'PERSIST_LOGIN_SUCCESS';
const PERSIST_LOGIN_FAIL = 'PERSIST_LOGIN_FAIL';
const FIRST_LOGIN_SUCCESS = 'FIRST_LOGIN_SUCCESS';
const COMPLETE_NEW_PASSWORD_SUCCESS = 'COMPLETE_NEW_PASSWORD_SUCCESS';
const LOGIN_START = 'LOGIN_START';
const REFRESH_USER = 'REFRESH_USER';
const REFRESH_USER_ATTRS = 'REFRESH_USER_ATTRS';
const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
const LOGIN_FAIL = 'LOGIN_FAIL';
const LOGOUT = 'LOGOUT';
const TOGGLE_NAVBAR = 'TOGGLE_NAVBAR';
const COMPLETE_NEW_PASSWORD_TIMEOUT = 'COMPLETE_NEW_PASSWORD_TIMEOUT';

export const userGroups = {
    ADMIN: 'admin',
    SPOTIFY: 'spotify'
};

export const appActions = {
    PERSIST_LOGIN_START,
    PERSIST_LOGIN_SUCCESS,
    PERSIST_LOGIN_FAIL,
    FIRST_LOGIN_SUCCESS,
    COMPLETE_NEW_PASSWORD_SUCCESS,
    LOGIN_START,
    LOGIN_SUCCESS,
    REFRESH_USER_ATTRS,
    REFRESH_USER,
    LOGIN_FAIL,
    LOGOUT,
    TOGGLE_NAVBAR,
    COMPLETE_NEW_PASSWORD_TIMEOUT
};

export const AuthContext = createContext({});

// useReducer Initial State
const initialState = {
    isLoading: true,
    user: null,
    isDarkMode: false,
    isNavbarOpen: false,
    errors: null,
    intendedRoute: '/'
};

const authReducer = (state = {}, action = null) => {
    switch (action.type) {
        case appActions.PERSIST_LOGIN_START: {
            return {
                ...state,
                isLoading: true
            };
        }
        case appActions.PERSIST_LOGIN_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                user: action.payload.user
            };
        }
        case appActions.PERSIST_LOGIN_FAIL: {
            return {
                ...state,
                isLoading: false
            };
        }
        case appActions.FIRST_LOGIN_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                user: action.payload.user
            };
        }
        case appActions.COMPLETE_NEW_PASSWORD_SUCCESS: {
            return {
                ...state,
                user: null,
                isLoading: false
            };
        }
        case appActions.COMPLETE_NEW_PASSWORD_TIMEOUT: {
            return {
                ...state,
                user: null
            };
        }
        case appActions.LOGIN_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                user: action.payload.user
            };
        }
        case appActions.LOGOUT: {
            return {
                ...initialState,
                isLoading: false
            };
        }
        case appActions.TOGGLE_NAVBAR: {
            return {
                ...state,
                isNavbarOpen: !state.isNavbarOpen
            };
        }
        case appActions.REFRESH_USER_ATTRS: {
            return {
                ...state,
                user: {
                    ...state.user,
                    attributes: {
                        ...state.user.attributes,
                        ...action.payload.updatedUserAttributes
                    }
                }
            };
        }
        case appActions.REFRESH_USER: {
            return {
                ...state,
                user: action.user
            };
        }
        default:
            return state;
    }
};

export const AuthProvider = (props) => {
    const [state, dispatch] = useReducer(authReducer, initialState);

    return (
        <AuthContext.Provider
            {...props}
            value={{
                state,
                dispatch
            }}
        />
    );
};
